import { isLiveStatus } from "../../../types";
import { DealCategory } from "../../../models/deals";
export const requiredString = (value) => {
    return !value?.length ? "This field is required" : undefined;
};
/**
 * Targeting-tab keys, per the DEL-5153 spike. PG Deal line items don't use line-item-level
 * targeting at all (it's handled entirely through the deal), so these are exempt from
 * validation regardless of the line item's draft/live status.
 *
 * Deliberately excludes "bookedImpressions": per the DEL-1560 backend audit, the backend still
 * requires a goal at READY and roger uses it for pacing classification/reporting, even though
 * PG lines aren't paced against it. Do not add it here.
 *
 * Exported (as a widened ReadonlySet<string>) so smithers' getLineItemTabForError can import
 * this instead of hand-copying its own list — the two lists drifted before this was shared.
 */
const targetingTabKeys = new Set([
    "deviceCaps",
    "frequencies",
    "frequencies.day",
    "frequencies.week",
    "frequencies.month",
    "dayparts",
    "productId",
    "publisherGroupId",
    "geoTargeting",
    "geofence",
    "confirmedRegionalRestrictions",
    "confirmedSensitiveCategories",
    "confirmedDeliveryImpact",
    "georecency.circles",
    "georecency.duration",
    "confirmedHealthcare",
    "confirmedDataUsage",
    "adPositions"
]);
export const TARGETING_TAB_KEYS = targetingTabKeys;
/**
 * Determine if a line item should be validated based on provided key & lineItem's status.
 */
export const shouldValidateOnLineItem = (lineItem, key) => {
    if (key && targetingTabKeys.has(key) && lineItem?.dealCategory === DealCategory.PG_DEAL) {
        return false;
    }
    // Keys that always validate regardless of draft/live status. This is a distinct concept from
    // TARGETING_TAB_KEYS above (which exists to support the PG Deal targeting bypass + shared UI
    // error suppression). A key can belong to either list or both, so update each list intentionally.
    switch (key) {
        case "name":
        case "endDate":
        case "startDate":
        case "dayparts":
        case "deviceCaps":
        case "frequencies":
        case "geofence":
        case "confirmedRegionalRestrictions":
        case "confirmedSensitiveCategories":
        case "confirmedDeliveryImpact":
        case "georecency.circles":
        case "georecency.duration":
        case "confirmedHealthcare":
        case "confirmedDataUsage":
        case "attachedCreatives.trackingPixels": // BE blocks invalid URLS
        case "attachedCreatives.clickThroughUrl": // BE blocks invalid URLS
        case "attachedCreatives.startDatesInRange":
        case "attachedCreatives.endDatesInRange":
        case "attachedCreatives.weight": // BE blocks if weight is 0
        case "attachedCreatives.flightName": // Validate format if provided
            return true;
        // A PG Deal draft with no deal isn't usable — unlike Supply Selector, this must block
        // even before the line item goes live (see the live-only default case below).
        case "deals.empty":
            return lineItem?.dealCategory === DealCategory.PG_DEAL;
        default:
            return isLiveStatus(lineItem?.status);
    }
};
//# sourceMappingURL=generic.js.map